export default class Item {
   type : string = '';
   route: string = '';
   filename: string = '';
   portada: string = '';
   extension: string = 'pdf';
   xlsx: boolean = false;
   docx: boolean = false;
   data:  Array<Item> = [];
   prev?: Item;

    constructor(data: any) {
        this.parse(data);
    }
    private parse(attr : any){
        this.type = attr.type;
        this.route = attr.route;
        this.filename = attr.filename;
        this.portada = attr.portada;
        this.xlsx = attr.xlsx || false;
        this.docx = attr.docx || false;
        if(attr.prev){
            this.prev = new Item(attr.prev);
        }
        if(!attr.data) return;
        attr.data.forEach( (item : any) => {
            const newItem = new Item(item);
            this.data.push(newItem);
        });
    }
}
